import { render, staticRenderFns } from "./InstituteChainMember.vue?vue&type=template&id=4fcb4ca8"
import script from "./InstituteChainMember.vue?vue&type=script&lang=js"
export * from "./InstituteChainMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports